import Echarts from 'echarts'
export default {
  data() {
    return {
      colorList: ['#7192e5', '#5290ae'],
      pieMix: {
        label: {
          show: true,
          // color: '#fff',
          fontSize: 12,
          position:'outside',
          formatter: function(params){
            let {name,percent} = params;
            if(name.length > 5){
              return name.slice(0,5) + '\n' + name.slice(5) + ":" + percent + "%\n"
            }
            return `${name}\n${percent}%\n`
          },
          align:'right'
        }, 
        labelLine:{
           normal: {
                // length: 10,
                // length2: 50,
                lineStyle: {
                    width: 1
                }
            }
        },    
        color: ['#008ed8', '#f7eb71', '#f5af9c', '#f5817d']
      },
      ringMix: {
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 16,
            color: '#fff',
            fontWeight: 'bold'
          }
        },
        radius: ['17%', '25%'],
        center: ['80%', '85%'],
        color: ['#7192e5','#0087cd', '#f29378', '#994d50']
      },
      areaStyle: {
        normal: {
          color: new Echarts.graphic.LinearGradient(
            0,
            0,
            0,
            1,
            [{
              offset: 0,
              color: 'rgba(195, 95, 95, 1)'
            },
            {
              offset: 1,
              color: 'rgba(195, 95, 95,0)'
            }
            ],
            false
          )
          // shadowColor: 'rgba(195, 95, 95, 0.1)',
          // shadowBlur: 10
        }
      }
    }
  },
  methods: {
    hexToRgba(hex, opacity) {
      let rgbaColor = ''
      const reg = /^#[\da-f]{6}$/i
      if (reg.test(hex)) {
        rgbaColor = `rgba(${parseInt('0x' + hex.slice(1, 3))},${parseInt(
          '0x' + hex.slice(3, 5)
        )},${parseInt('0x' + hex.slice(5, 7))},${opacity})`
      }
      return rgbaColor
    },
    getXAxis(res,reverse) {
      if(!reverse){
        return Object.assign({}, this.AxisBase, {
          type:'category',
          data: this.getAxis('name', res),
          boundaryGap: [5, 5],
          axisLabel: {
            interval: 0,
            fontSize: 12,
            color: '#fff',
            // formatter: function(params) {
            //   if (params && params !== '') {
            //     return params.slice(0, 2)
            //   }
            // }
          }
        })
      }else{
        return {
          type:'value',
          splitLine: {show: false},
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: { show:false}
        }
      }
     
    },
    getYAxis(res,reverse){
      if(!reverse){
        let self = this;
        return Object.assign({}, this.AxisBase, {
          type:'value',
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 12,
            formatter: function(value) {
              if (value === 0) {
                return 0
              } else {
               let ws = self.computeWs(value);
                switch (ws) {
                  case 4:
                    return `${value / 1000}千`
                  case 5:
                    return `${value / 10000}万`
                  default:
                    return value
                }
              }
            }
          },
          // min: -100,
          alignWidthLabel: true
        })
      }else{
       return Object.assign({},this.getXAxis(res,false),{
        type:'category',
        axisLabel: { show:false},
        splitLine: {show: false},
        axisTick: { show: false },
        axisLine: { show: false },
       })
      }
     
    },
    getAxis(key, res) {
      if(!this.isLegend){
        return res[0].map(item=>item[key])
      }else{
        return res.map(item => item[key])
      }      
    },
    getLegend(isLegend,list){
      if(!isLegend){
        return {}
      }else{        
        return list[0].data.map(item=> {return item.name})
      }
    },
    getBarLineSeries(list, seriesType) {
      if(!this.isLegend){
        return list.reduce((temp, itemData, idx) => {
          let currentStyle = Object.assign({}, this.styleBase)
          // console.log('currentStyle', currentStyle)
          const currentLabel = Object.assign({}, this.labelBase)
          let symbol = {}
          if (seriesType[idx] === 'scatter') {
            currentLabel.label.show = false
            symbol = {
              showSymbol: true,
              symbolSize: 20
            }
          } else {
            currentLabel.label.show = true
            symbol = {
              showSymbol: false,
              symbolSize: 0
            }
          }
          temp.push({
            type:this.seriesType[idx],
            data: itemData.map(item => item.value),
            // areaStyle: this.areaStyle,
            ...currentStyle,
            ...currentLabel,
            ...(this.reverse ? {
              label:{
                normal: {
                  show: true,
                  position: 'insideLeft',
                  formatter(params){
                      return params.name;
                  }
                }
              },
              barWidth:32,
              barGap:'80%',/*多个并排柱子设置柱子之间的间距*/
              barCategoryGap:'50%',/*多个并排柱子设置柱子之间的间距*/
              itemStyle:{
                normal: {
                  barBorderRadius: [5,5,5,5,5],
                  interval:10,
              }
            }
            } : {}),
            ...symbol
          })
          return temp
        }, [])
      }else{
       return this.legend.map(item=>{
          return {
            type:this.seriesType[0],            
            name:item,
            ...this.styleBase,
            barWidth:20,
            showSymbol:false,
            barGap:'80%',/*多个并排柱子设置柱子之间的间距*/
            barCategoryGap:'50%',/*多个并排柱子设置柱子之间的间距*/
            data: this.list.reduce((cur,next)=>{
              cur.push(next.data.find(it=>it.name === item).value)
              return cur
            },[])
          }
        })
      }
    },
    getPieSeries(list,type,color) {
      let currentMix = (type === 'pie' ? this.pieMix : this.ringMix)
      currentMix = Object.assign({},currentMix,{color:color});
      const series = {
        type: 'pie',
        center: ['55%', '60%'],
        radius: ['40%', '60%'],
        minAngle: 10,  // 设置每块扇形的最小占比
        // center: ['40%', '50%'],
        data: list.map(item => {
          return {
            name: item.name,
            value: parseInt(item.value)
          }
        }),
        avoidLabelOverlap: false,
        ...currentMix
      }
      // console.log('series', series)
      return series
    },
    computeWs(data) {
      let len = 0
      let maxjs = parseInt(data)
      while (maxjs > 0) {
        maxjs = Math.floor(parseInt(maxjs) / 10)
        len++
      }
      return len
    }
  }
}